// extracted by mini-css-extract-plugin
export default {"overlay":"CourseBoxOverlay_overlay__lqIhz","virtual":"CourseBoxOverlay_virtual__EbrL7"};